import { requestService } from 'shared/utils/services/requestService';

export async function updateRegionPreferences(country) {
  return requestService({
    url: '/web-api/v1/region_preferences',
    method: 'post',
    data: JSON.stringify({
      region_preferences: {
        country,
      },
    }),
    withCredentials: true,
  });
}
